// extracted by mini-css-extract-plugin
module.exports = {"isAdminColumn":"AdministratorsPanel_isAdminColumn__2vGOs"};